import { QuestionOptionI18nBase } from "./base/root";
import { QuestionOptionI18nSubOption } from "./sub-option/root";

import type { StandardOptionI18nCategoriesAndManagerStore } from "../store/categories";

type Props = {
	standardOptionI18nCategoriesAndManagerStore: Omit<
		StandardOptionI18nCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
};

export const OptionI18nForm = ({ standardOptionI18nCategoriesAndManagerStore }: Props) => {
	const { base, subOption } = standardOptionI18nCategoriesAndManagerStore;

	return (
		<>
			<QuestionOptionI18nBase base={base} />
			<QuestionOptionI18nSubOption subOption={subOption} />
		</>
	);
};

OptionI18nForm.displayName = "OptionI18nForm";
